var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { convertMasterData } from '@spike/masterdata-action';
import { alertErrorHandler, showSuccess } from '@spike/notifications-action';
import axios from 'axios';
import _ from 'lodash';
import clone from 'lodash/clone';
import { serialize } from 'object-to-formdata';
import { MARKETPLACE_CLEAR_ACTION_TYPE, MARKETPLACE_DEACTIVATE_START_ACTION_TYPE, MARKETPLACE_DEACTIVATE_SUCCESS_ACTION_TYPE, MARKETPLACE_ERROR_ACTION_TYPE, MARKETPLACE_FETCH_ACTION_TYPE, MARKETPLACE_FETCH_SUCCESS_ACTION_TYPE, MARKETPLACE_RESET_ACTION_TYPE, MARKETPLACE_SAVE_ACTION_TYPE, MARKETPLACE_SAVE_SUCCESS_ACTION_TYPE, MARKETPLACE_SET_ACTION_TYPE, MARKETPLACE_CHANGE_OLB_STATUS_START_ACTION_TYPE, MARKETPLACE_CHANGE_OLB_STATUS_SUCCESS_ACTION_TYPE, MARKETPLACE_SAVE_OLB_LIMITS_START_ACTION_TYPE, MARKETPLACE_SAVE_OLB_LIMITS_SUCCESS_ACTION_TYPE, MARKETPLACE_SAVE_OLB_ALLOW_SELECT_STAFF_START_ACTION_TYPE, MARKETPLACE_SAVE_OLB_ALLOW_SELECT_STAFF_SUCCESS_ACTION_TYPE, MARKETPLACE_SAVE_OLB_ALLOW_NEW_CLIENTS_START_ACTION_TYPE, MARKETPLACE_SAVE_OLB_ALLOW_NEW_CLIENTS_SUCCESS_ACTION_TYPE, MARKETPLACE_SAVE_OLB_BOOKING_REQUEST_START_ACTION_TYPE, MARKETPLACE_SAVE_OLB_BOOKING_REQUEST_SUCCESS_ACTION_TYPE, MARKETPLACE_CHANGE_INTAKE_FORM_STATUS_START_ACTION_TYPE, MARKETPLACE_CHANGE_INTAKE_FORM_STATUS_SUCCESS_ACTION_TYPE, MARKETPLACE_SAVE_SCHEDULE_TYPE_START_ACTION_TYPE, MARKETPLACE_SAVE_SCHEDULE_TYPE_SUCCESS_ACTION_TYPE, MARKETPLACE_SAVE_INTAKE_FORM_QUESTIONS_START_ACTION_TYPE, MARKETPLACE_SAVE_INTAKE_FORM_QUESTIONS_SUCCESS_ACTION_TYPE, MARKETPLACE_GET_PET_TAGS_START_ACTION_TYPE, MARKETPLACE_GET_PET_TAGS_SUCCESS_ACTION_TYPE } from './MarketplaceActionsTypes';
import { convertMarketplace } from './MarketplaceConverter';
var marketplacesUrl = '/marketplaces/';
export var fetchMarketplaceThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(getMarketplaceThunk(apiClientWrapper, true));
            return [2 /*return*/];
        });
    }); };
};
export var refreshMarketplaceThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(getMarketplaceThunk(apiClientWrapper, false));
            return [2 /*return*/];
        });
    }); };
};
var getMarketplaceThunk = function (apiClientWrapper, removeLoaded) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    removeLoaded && dispatch(clear());
                    dispatch(fetchStart());
                    url = "".concat(marketplacesUrl).concat(apiClientWrapper.marketplaceId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchSucces(convertMarketplace(response.data, apiClientWrapper.masterData)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!axios.isCancel(apiError_1)) {
                        dispatch(error());
                        alertErrorHandler(apiError_1, dispatch, 'Error loading marketplace.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveMarketplaceThunk = function (apiClientWrapper, marketplace, setTimeZone) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var prevMarketplace, spayAndNeuter, url, taxesGetUrl, taxesGetResponse, actualTaxes, requirementsList, marketplaceRequest, formData, options, response, apiError_2;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        return __generator(this, function (_0) {
            switch (_0.label) {
                case 0:
                    prevMarketplace = clone(getState().marketplace.marketplace);
                    dispatch(deactivateStart());
                    spayAndNeuter = 'spay_and_neuter';
                    url = "".concat(marketplacesUrl).concat(apiClientWrapper.marketplaceId);
                    taxesGetUrl = "taxes?marketplace_id=".concat(apiClientWrapper.marketplaceId);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(taxesGetUrl, apiClientWrapper.requestConfig)];
                case 1:
                    taxesGetResponse = _0.sent();
                    actualTaxes = taxesGetResponse.data.map(function (tax) { return ({
                        id: tax.id,
                        uuid: tax.uuid,
                        name: tax.name,
                        value: tax.percentage,
                    }); });
                    requirementsList = __spreadArray(__spreadArray([], marketplace.requirements.requirements.map(function (r) { return r.id; }), true), marketplace.requirements.otherRequirements, true);
                    if (marketplace.requirements.spayedAndNeureted) {
                        requirementsList.push(spayAndNeuter);
                    }
                    if (requirementsList.length === 0) {
                        requirementsList = [];
                    }
                    marketplaceRequest = {
                        marketplace_id: marketplace.id || apiClientWrapper.marketplaceId,
                        marketplace: {
                            business_name: marketplace.basics.businessName,
                            locations_count: marketplace.marketingInfo.locationsCount,
                            years_in_business: marketplace.additionalInfo.yearsInBusiness,
                            employees: marketplace.additionalInfo.numberOfEmployees,
                            business_area_list: marketplace.businessAreas.map(function (ba) { return ba.id; }),
                            pet_list: _.keys(marketplace.petTypes).filter(function (id) { var _a, _b; return (_b = (_a = marketplace.petTypes[id]) === null || _a === void 0 ? void 0 : _a.enabled) !== null && _b !== void 0 ? _b : false; }),
                            pet_requirement_list: requirementsList,
                            calendars_attributes: [
                                {
                                    id: marketplace.schedule.id,
                                    marketplace_id: marketplace.id || apiClientWrapper.marketplaceId,
                                    range: JSON.stringify(marketplace.schedule.week),
                                    time_zone: marketplace.schedule.timeZone,
                                },
                            ],
                            addresses_attributes: [
                                {
                                    id: marketplace.basics.address.id,
                                    marketplace_id: marketplace.id || apiClientWrapper.marketplaceId,
                                    name: marketplace.basics.businessName,
                                    address_line_one: marketplace.basics.address.street,
                                    address_line_two: marketplace.basics.address.suite,
                                    city: marketplace.basics.address.city,
                                    state: marketplace.basics.address.state,
                                    zipcode: marketplace.basics.address.zipcode,
                                    country: (_a = marketplace.basics.address.country) === null || _a === void 0 ? void 0 : _a.id,
                                    amenity_list: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], marketplace.grooming.holdingAreas.map(function (ha) { return ha.id; }), true), marketplace.grooming.security.map(function (s) { return s.id; }), true), marketplace.grooming.sizeSeparation.map(function (ss) { return ss.id; }), true), marketplace.grooming.visibility.map(function (v) { return v.id; }), true), marketplace.grooming.others, true),
                                    staff_training_list: __spreadArray(__spreadArray([], marketplace.staffTraining.trainings.map(function (t) { return t.id; }), true), marketplace.staffTraining.otherTrainings, true),
                                },
                            ],
                            phone: marketplace.basics.phone,
                            email: marketplace.basics.email,
                            website: marketplace.basics.website,
                            dogs_detail: JSON.stringify({
                                enabled: (_c = (_b = marketplace.petTypes.dogs) === null || _b === void 0 ? void 0 : _b.enabled) !== null && _c !== void 0 ? _c : false,
                                ages: (((_d = marketplace.petTypes.dogs) === null || _d === void 0 ? void 0 : _d.ages) || []),
                                sizes: ((_f = (_e = marketplace.petTypes.dogs) === null || _e === void 0 ? void 0 : _e.sizes) !== null && _f !== void 0 ? _f : []).map(function (orderedOption) { return orderedOption.element; }),
                                hairTypes: ((_h = (_g = marketplace.petTypes.dogs) === null || _g === void 0 ? void 0 : _g.hairTypes) !== null && _h !== void 0 ? _h : []).map(function (orderedOption) { return orderedOption.element; }),
                                hairLengths: ((_k = (_j = marketplace.petTypes.dogs) === null || _j === void 0 ? void 0 : _j.hairLengths) !== null && _k !== void 0 ? _k : []).map(function (orderedOption) { return orderedOption.element; }),
                            }),
                            cats_detail: JSON.stringify({
                                enabled: (_m = (_l = marketplace.petTypes.cats) === null || _l === void 0 ? void 0 : _l.enabled) !== null && _m !== void 0 ? _m : false,
                                ages: (_p = (_o = marketplace.petTypes.cats) === null || _o === void 0 ? void 0 : _o.ages) !== null && _p !== void 0 ? _p : [],
                                sizes: ((_r = (_q = marketplace.petTypes.cats) === null || _q === void 0 ? void 0 : _q.sizes) !== null && _r !== void 0 ? _r : []).map(function (orderedOption) { return orderedOption.element; }),
                                hairTypes: ((_t = (_s = marketplace.petTypes.cats) === null || _s === void 0 ? void 0 : _s.hairTypes) !== null && _t !== void 0 ? _t : []).map(function (orderedOption) { return orderedOption.element; }),
                                hairLengths: ((_v = (_u = marketplace.petTypes.cats) === null || _u === void 0 ? void 0 : _u.hairLengths) !== null && _v !== void 0 ? _v : []).map(function (orderedOption) { return orderedOption.element; }),
                            }),
                            exotics_detail: JSON.stringify({
                                enabled: (_x = (_w = marketplace.petTypes.exotics) === null || _w === void 0 ? void 0 : _w.enabled) !== null && _x !== void 0 ? _x : false,
                                types: marketplace.petTypes.exotics.types,
                                others: marketplace.petTypes.exotics.others,
                                sizes: (marketplace.petTypes.exotics.sizes || []).map(function (orderedOption) { return orderedOption.element; }),
                            }),
                            special_hours_attributes: convertSpecialHours(marketplace, prevMarketplace),
                            optin_email_new_bookings: marketplace.notifications.newBookings,
                            optin_email_cancellations: marketplace.notifications.appointmentCancellations,
                            email_content: marketplace.notifications.emailContent.map(function (line) { return line.trim(); }).filter(function (line) { return line.length > 0; }).join('\n'),
                            ga_tracking_id: marketplace.integrations.googleAnalyticsTrackingId,
                            mobile_business: marketplace.additionalInfo.mobileBusiness,
                            local_business: marketplace.additionalInfo.localBusiness,
                            athome_business: marketplace.additionalInfo.atHomeBusiness,
                            inhome_business: marketplace.additionalInfo.inHomeBusiness,
                            online_booking: marketplace.notifications.client,
                            onboarding_step: marketplace.onboardingStep,
                            deposit_category: marketplace.deposit.type,
                            deposit_value: marketplace.deposit.value || null,
                            taxes_attributes: convertTaxes(marketplace.taxes, actualTaxes),
                            custom_pet_positive_personality_list: marketplace.petPositivePersonality,
                            custom_pet_negative_personality_list: marketplace.petNegativePersonality,
                            tip_rates_attributes: marketplace.tips.map(function (tip) { return ({ id: tip.id, uuid: tip.uuid, value: tip.percentage }); }),
                            twilio_phone_number: marketplace.twilioPhoneNumber,
                            settings_attributes: convertNotificationSettings(marketplace),
                            url_slug: marketplace.onlineBooking.slug,
                            olb_minimum_lead_time: (_y = marketplace.onlineBooking.from) === null || _y === void 0 ? void 0 : _y.id,
                            olb_maximum_lead_time: (_z = marketplace.onlineBooking.to) === null || _z === void 0 ? void 0 : _z.id,
                            olb_booking_request: marketplace.onlineBooking.bookingRequestsEnabled,
                            pricing_option: marketplace.onlineBooking.pricingOption,
                        },
                    };
                    formData = new FormData();
                    options = {
                        indices: false,
                        nullsAsUndefineds: false,
                        booleansAsIntegers: false,
                        allowEmptyArrays: true,
                    };
                    formData = serialize(marketplaceRequest, options, formData);
                    if (marketplace.logos.imageFileToUpload && !marketplace.logos.imageRemove) {
                        formData.append('marketplace[logo_main]', marketplace.logos.imageFileToUpload);
                    }
                    if (marketplace.logos.imageRemove) {
                        formData.append('marketplace[logo_main]', new Blob());
                    }
                    if (marketplace.logos.promoImageSecondaryFileToUpload && !marketplace.logos.promoImageSecondaryRemove) {
                        formData.append('marketplace[logo_secondary]', marketplace.logos.promoImageSecondaryFileToUpload);
                    }
                    if (marketplace.logos.promoImageSecondaryRemove) {
                        formData.append('marketplace[logo_secondary]', new Blob());
                    }
                    if (marketplace.logos.promoFileToUpload && !marketplace.logos.promoImageRemove) {
                        formData.append('marketplace[booknow_image]', marketplace.logos.promoFileToUpload);
                    }
                    if (marketplace.logos.promoImageRemove) {
                        formData.append('marketplace[booknow_image]', new Blob());
                    }
                    _0.label = 2;
                case 2:
                    _0.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, formData, apiClientWrapper.multipartRequestConfig)];
                case 3:
                    response = _0.sent();
                    dispatch(saveSuccess(convertMarketplace(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess('Marketplace saved!'));
                    setTimeZone(marketplace.schedule.timeZone, marketplace.id, dispatch);
                    return [3 /*break*/, 5];
                case 4:
                    apiError_2 = _0.sent();
                    if (!axios.isCancel(apiError_2)) {
                        dispatch(error());
                        alertErrorHandler(apiError_2, dispatch, 'Error saving marketplace.');
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var deactivateMarketplaceThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveStart());
                    url = "".concat(marketplacesUrl).concat(apiClientWrapper.marketplaceId);
                    body = {
                        marketplace_id: apiClientWrapper.marketplaceId,
                        marketplace: {
                            id: apiClientWrapper.marketplaceId,
                            active: false,
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(deactivateSuccess(convertMarketplace(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess('Marketplace deactivated!'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _a.sent();
                    if (!axios.isCancel(apiError_3)) {
                        dispatch(error());
                        alertErrorHandler(apiError_3, dispatch, 'Error deactivating marketplace.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var changeOlbStatusThunk = function (apiClientWrapper, active) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, bodyRequest, response, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(changeOlbStatusStart());
                    url = "".concat(marketplacesUrl).concat(apiClientWrapper.marketplaceId);
                    bodyRequest = {
                        marketplace_id: apiClientWrapper.marketplaceId || apiClientWrapper.marketplaceId,
                        marketplace: {
                            olb_enabled: active,
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, bodyRequest, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(changeOlbStatusSuccess(convertMarketplace(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess(active ? 'Enabled Online Booking' : 'Disabled Online Booking'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    if (!axios.isCancel(apiError_4)) {
                        dispatch(error());
                        alertErrorHandler(apiError_4, dispatch, "Error ".concat(active ? 'enabling' : 'disabling', " Online Booking."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveOlbLimitsThunk = function (apiClientWrapper, from, to) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, bodyRequest, response, apiError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveOlbLimitsStart());
                    url = "".concat(marketplacesUrl).concat(apiClientWrapper.marketplaceId);
                    bodyRequest = {
                        marketplace_id: apiClientWrapper.marketplaceId || apiClientWrapper.marketplaceId,
                        marketplace: {
                            olb_minimum_lead_time: from === null || from === void 0 ? void 0 : from.id,
                            olb_maximum_lead_time: to === null || to === void 0 ? void 0 : to.id,
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, bodyRequest, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveOlbLimitsSuccess(convertMarketplace(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess('Limits changed!'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_5 = _a.sent();
                    if (!axios.isCancel(apiError_5)) {
                        dispatch(error());
                        alertErrorHandler(apiError_5, dispatch, 'Error saving limits.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveOlbAllowSelectStaffThunk = function (apiClientWrapper, allowSelectStaff) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, bodyRequest, response, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveOlbAllowSelectStaffStart());
                    url = "".concat(marketplacesUrl).concat(apiClientWrapper.marketplaceId);
                    bodyRequest = {
                        marketplace_id: apiClientWrapper.marketplaceId || apiClientWrapper.marketplaceId,
                        marketplace: {
                            olb_can_select_staff: allowSelectStaff,
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, bodyRequest, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveOlbAllowSelectStaffSuccess(convertMarketplace(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess('Select staff changed!'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_6 = _a.sent();
                    if (!axios.isCancel(apiError_6)) {
                        dispatch(error());
                        alertErrorHandler(apiError_6, dispatch, 'Error saving select staff.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveOlbAllowNewClientsThunk = function (apiClientWrapper, allowNewClients) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, bodyRequest, response, apiError_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveOlbAllowNewClientsStart());
                    url = "".concat(marketplacesUrl).concat(apiClientWrapper.marketplaceId);
                    bodyRequest = {
                        marketplace_id: apiClientWrapper.marketplaceId || apiClientWrapper.marketplaceId,
                        marketplace: {
                            olb_accept_new_client: allowNewClients,
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, bodyRequest, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveOlbAllowNewClientsSuccess(convertMarketplace(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess('New clients changed!'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_7 = _a.sent();
                    if (!axios.isCancel(apiError_7)) {
                        dispatch(error());
                        alertErrorHandler(apiError_7, dispatch, 'Error saving new clients.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var changeIntakeFormStatusThunk = function (apiClientWrapper, active) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, bodyRequest, response, apiError_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(changeIntakeFormStatusStart());
                    url = "".concat(marketplacesUrl).concat(apiClientWrapper.marketplaceId);
                    bodyRequest = {
                        marketplace_id: apiClientWrapper.marketplaceId || apiClientWrapper.marketplaceId,
                        marketplace: {
                            intake_form: active,
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, bodyRequest, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(changeIntakeFormStatusSuccess(convertMarketplace(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess(active ? 'Enabled Intake Form' : 'Disabled Intake Form'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_8 = _a.sent();
                    if (!axios.isCancel(apiError_8)) {
                        dispatch(error());
                        alertErrorHandler(apiError_8, dispatch, "Error ".concat(active ? 'enabling' : 'disabling', " Intake Form."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveOlbBookingRequestThunk = function (apiClientWrapper, bookingRequestEnabled) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, bodyRequest, response, apiError_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveOlbBookingRequestStart());
                    url = "".concat(marketplacesUrl).concat(apiClientWrapper.marketplaceId);
                    bodyRequest = {
                        marketplace_id: apiClientWrapper.marketplaceId || apiClientWrapper.marketplaceId,
                        marketplace: {
                            olb_booking_request: bookingRequestEnabled,
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, bodyRequest, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveOlbBookingRequestSuccess(convertMarketplace(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess('Booking requests changed!'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_9 = _a.sent();
                    if (!axios.isCancel(apiError_9)) {
                        dispatch(error());
                        alertErrorHandler(apiError_9, dispatch, 'Error saving booking requests.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveScheduleTypeThunk = function (apiClientWrapper, scheduleType) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, bodyRequest, response, apiError_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveScheduleTypeStart());
                    url = "".concat(marketplacesUrl).concat(apiClientWrapper.marketplaceId);
                    bodyRequest = {
                        marketplace_id: apiClientWrapper.marketplaceId || apiClientWrapper.marketplaceId,
                        marketplace: {
                            schedule_type: scheduleType,
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, bodyRequest, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveScheduleTypeSuccess(convertMarketplace(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess('Schedule type changed!'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_10 = _a.sent();
                    if (!axios.isCancel(apiError_10)) {
                        dispatch(error());
                        alertErrorHandler(apiError_10, dispatch, 'Error saving schedule type.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveIntakeFormCustomQuestionsThunk = function (apiClientWrapper, enabled, questions, deletedQuestionIds) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, customQuestions, bodyRequest, response, apiError_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveIntakeFormQuestionsStart());
                    url = "".concat(marketplacesUrl).concat(apiClientWrapper.marketplaceId);
                    customQuestions = questions.map(function (question) { return ({
                        id: question.id === 0 ? null : question.id,
                        marketplace_id: question.marketplaceId,
                        display_order: question.order,
                        question_text: question.question,
                        enabled: question.enabled,
                        required: question.required,
                        category: question.category,
                        created_at: question.createdAt.toISOString(),
                        updated_at: question.updatedAt.toISOString(),
                    }); });
                    bodyRequest = {
                        marketplace_id: apiClientWrapper.marketplaceId || apiClientWrapper.marketplaceId,
                        marketplace: {
                            custom_questions_enabled: enabled,
                            custom_questions_attributes: __spreadArray(__spreadArray([], customQuestions, true), deletedQuestionIds.map(function (id) { return ({ id: id, _destroy: true }); }), true),
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, bodyRequest, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(saveIntakeFormQuestionsSuccess(convertMarketplace(response.data, apiClientWrapper.masterData)));
                    dispatch(showSuccess('Intake form questions saved!'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_11 = _a.sent();
                    if (!axios.isCancel(apiError_11)) {
                        dispatch(error());
                        alertErrorHandler(apiError_11, dispatch, 'Error saving intake form questions.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getPetTagsThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getPetTagsStart());
                    url = "/marketplace/pet_personality_list?marketplace_id=".concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getPetTagsSuccess(response.data));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_12 = _a.sent();
                    if (!axios.isCancel(apiError_12)) {
                        dispatch(error());
                        alertErrorHandler(apiError_12, dispatch, 'Error loading marketplace.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var reset = function () {
    return {
        type: MARKETPLACE_RESET_ACTION_TYPE,
    };
};
var clear = function () {
    return {
        type: MARKETPLACE_CLEAR_ACTION_TYPE,
    };
};
var fetchStart = function () {
    return {
        type: MARKETPLACE_FETCH_ACTION_TYPE,
    };
};
export var fetchSucces = function (marketplace) {
    return {
        type: MARKETPLACE_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace: marketplace,
        },
    };
};
export var setMarketplaceDto = function (marketplaceDto, masterDataDto) {
    return setMarketplace(convertMarketplace(marketplaceDto, convertMasterData(masterDataDto)));
};
export var setMarketplace = function (marketplace) {
    return {
        type: MARKETPLACE_SET_ACTION_TYPE,
        payload: {
            marketplace: marketplace,
        },
    };
};
var saveStart = function () {
    return {
        type: MARKETPLACE_SAVE_ACTION_TYPE,
    };
};
var saveSuccess = function (marketplace) {
    return {
        type: MARKETPLACE_SAVE_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace: marketplace,
        },
    };
};
var deactivateStart = function () {
    return {
        type: MARKETPLACE_DEACTIVATE_START_ACTION_TYPE,
    };
};
var deactivateSuccess = function (marketplace) {
    return {
        type: MARKETPLACE_DEACTIVATE_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace: marketplace,
        },
    };
};
var changeOlbStatusStart = function () {
    return {
        type: MARKETPLACE_CHANGE_OLB_STATUS_START_ACTION_TYPE,
    };
};
var changeOlbStatusSuccess = function (marketplace) {
    return {
        type: MARKETPLACE_CHANGE_OLB_STATUS_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace: marketplace
        }
    };
};
var saveOlbLimitsStart = function () {
    return {
        type: MARKETPLACE_SAVE_OLB_LIMITS_START_ACTION_TYPE,
    };
};
var saveOlbLimitsSuccess = function (marketplace) {
    return {
        type: MARKETPLACE_SAVE_OLB_LIMITS_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace: marketplace
        }
    };
};
var saveOlbAllowSelectStaffStart = function () {
    return {
        type: MARKETPLACE_SAVE_OLB_ALLOW_SELECT_STAFF_START_ACTION_TYPE,
    };
};
var saveOlbAllowSelectStaffSuccess = function (marketplace) {
    return {
        type: MARKETPLACE_SAVE_OLB_ALLOW_SELECT_STAFF_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace: marketplace
        }
    };
};
var saveOlbAllowNewClientsStart = function () {
    return {
        type: MARKETPLACE_SAVE_OLB_ALLOW_NEW_CLIENTS_START_ACTION_TYPE,
    };
};
var saveOlbAllowNewClientsSuccess = function (marketplace) {
    return {
        type: MARKETPLACE_SAVE_OLB_ALLOW_NEW_CLIENTS_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace: marketplace
        }
    };
};
var changeIntakeFormStatusStart = function () {
    return {
        type: MARKETPLACE_CHANGE_INTAKE_FORM_STATUS_START_ACTION_TYPE,
    };
};
var changeIntakeFormStatusSuccess = function (marketplace) {
    return {
        type: MARKETPLACE_CHANGE_INTAKE_FORM_STATUS_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace: marketplace
        }
    };
};
var saveOlbBookingRequestStart = function () {
    return {
        type: MARKETPLACE_SAVE_OLB_BOOKING_REQUEST_START_ACTION_TYPE,
    };
};
var saveOlbBookingRequestSuccess = function (marketplace) {
    return {
        type: MARKETPLACE_SAVE_OLB_BOOKING_REQUEST_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace: marketplace
        }
    };
};
var saveScheduleTypeStart = function () {
    return {
        type: MARKETPLACE_SAVE_SCHEDULE_TYPE_START_ACTION_TYPE,
    };
};
var saveScheduleTypeSuccess = function (marketplace) {
    return {
        type: MARKETPLACE_SAVE_SCHEDULE_TYPE_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace: marketplace
        }
    };
};
var saveIntakeFormQuestionsStart = function () {
    return {
        type: MARKETPLACE_SAVE_INTAKE_FORM_QUESTIONS_START_ACTION_TYPE,
    };
};
var saveIntakeFormQuestionsSuccess = function (marketplace) {
    return {
        type: MARKETPLACE_SAVE_INTAKE_FORM_QUESTIONS_SUCCESS_ACTION_TYPE,
        payload: {
            marketplace: marketplace
        }
    };
};
var getPetTagsStart = function () {
    return {
        type: MARKETPLACE_GET_PET_TAGS_START_ACTION_TYPE,
    };
};
var getPetTagsSuccess = function (petTags) {
    return {
        type: MARKETPLACE_GET_PET_TAGS_SUCCESS_ACTION_TYPE,
        payload: {
            petTags: petTags,
        },
    };
};
var error = function () {
    return {
        type: MARKETPLACE_ERROR_ACTION_TYPE,
    };
};
var convertSpecialHours = function (newMarketplace, prevMarketplace) {
    var newSpecialHoursIds = newMarketplace.schedule.specialHours.filter(function (sh) { return sh.id; }).map(function (sh) { return sh.id; });
    var specialHours = newMarketplace.schedule.specialHours.map(function (specialHour) { return ({
        id: specialHour.id,
        name: specialHour.name,
        business_hours: specialHour.businessHours ? JSON.stringify(specialHour.businessHours) : null,
        closed: specialHour.isClosed,
        date: specialHour.date,
        marketplace_id: newMarketplace.id,
    }); });
    var deletedSpecialHours = prevMarketplace.schedule.specialHours
        .filter(function (prev) { return !newSpecialHoursIds.includes(prev.id); })
        .map(function (sh) { return ({ id: sh.id, _destroy: true, marketplace_id: newMarketplace.id }); }) || [];
    return __spreadArray(__spreadArray([], deletedSpecialHours, true), specialHours, true);
};
var convertTaxes = function (taxesToPatch, actualTaxes) {
    var taxesToPatchMap = taxesToPatch.map(function (tax) { return ({
        id: tax.id,
        uuid: tax.uuid,
        name: tax.name,
        value: tax.percentage,
    }); });
    var taxesToRemoveMap = actualTaxes
        .filter(function (actualTax) { return !taxesToPatchMap.some(function (tax) { return tax.id === actualTax.id; }); })
        .map(function (actualTaxSave) { return ({ id: actualTaxSave.id, _destroy: true }); });
    var taxes = [];
    taxes.push.apply(taxes, __spreadArray(__spreadArray([], taxesToPatchMap, false), taxesToRemoveMap, false));
    return taxes;
};
var convertNotificationSettings = function (marketplace) {
    return marketplace.notifications.settings.map(function (setting) { return ({ id: setting.id, uuid: setting.uuid,
        description: setting.description, name: setting.option.name, key: setting.option.id, owner_id: marketplace.id, owner_type: "Marketplace", value: setting.reminderTime ? setting.reminderTime.id : setting.active ? 't' : 'f'
    }); });
};
